import { render, staticRenderFns } from "./chukou.vue?vue&type=template&id=c534cc32&scoped=true&"
import script from "./chukou.vue?vue&type=script&lang=js&"
export * from "./chukou.vue?vue&type=script&lang=js&"
import style0 from "./chukou.vue?vue&type=style&index=0&id=c534cc32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c534cc32",
  null
  
)

export default component.exports